export const teamName = {
  0: '-',
  1: '湖人',
  2: '公牛',
  3: '凯尔特人',
  4: '老鹰',
  5: '篮网',
  6: '骑士',
  7: '黄蜂',
  8: '尼克斯',
  9: '活塞',
  10: '热火',
  11: '76人',
  12: '猛龙',
  13: '步行者',
  14: '雄鹿',
  15: '魔术',
  16: '奇才',
  17: '雷霆',
  18: '狼队',
  19: '掘金',
  20: '开拓者',
  21: '爵士',
  22: '太阳',
  23: '国王',
  24: '快船',
  25: '勇士',
  26: '马刺',
  27: '小牛',
  28: '火箭',
  29: '灰熊',
  30: '鹈鹕',
  52: '游击队',
  56: '皇马',
  57: '',
  58: '',
  59: '比遜',
  63: '马卡比',
  64: '巴塞',
  65: '艾斯维尔',
  66: '',
  67: '蒙特帕奇',
  69: '',
  70: '费内巴切',
  71: '',
  74: '',
  75: '中央陆军',
  493: '八一',
  494: '云南',
  495: '广州',
  496: '新疆',
  497: '福建',
  498: '稠州',
  499: '河南',
  500: '江苏',
  501: '吉林',
  502: '广东',
  503: '山东',
  504: '上海',
  505: '北京',
  506: '辽宁',
  513: '西部',
  514: '东部',
  515: '',
  516: '新秀美国队',
  518: '北方明星',
  519: '南方明星',
  520: '飞翼',
  521: '太阳',
  522: '风暴',
  523: '火花',
  524: '',
  525: '神秘人',
  526: '银星',
  527: '彗星',
  528: '水星',
  529: '君主',
  530: '自由人',
  531: '狂热',
  532: '天猫',
  534: '',
  535: '',
  572: '深圳',
  574: '',
  576: '阿玛尼',
  708: '天空',
  710: '东岸明星队',
  711: '西岸明星队',
  722: '巴西女篮',
  724: '澳大利亚女篮',
  733: '',
  734: '中国女篮',
  768: '毕尔包',
  776: '',
  791: '广厦',
  792: '山西',
  802: '',
  806: '墨尔本',
  807: '阿德莱德36人',
  814: '新西兰破坏者',
  824: '布里斯班',
  825: '悉尼',
  848: 'ALBA柏林',
  870: '其姆奇',
  903: '日本女篮',
  1018: '',
  1023: '',
  1024: '',
  1059: '天津',
  1064: '青岛国信',
  1369: '',
  1379: '',
  1557: '',
  1558: '',
  1580: '梦想',
  1581: '四川',
  1587: '江苏同曦大圣',
  1654: '马卡比',
  1794: '南方星锐',
  1795: '北方星锐',
  1868: '巴乌鲁',
  1873: '弗兰门戈',
  1922: '北控',
  2374: '',
  3156: '查尔斯队',
  3157: '沙克队',
  3435: '中国国奥女篮',
  3684: '希尔队',
  3685: '韦伯队',
  3944: '新秀世界队',
  4033: '',
  5022: '勒布朗队',
  6283: '字母哥队'
}

export const matchType = {
  0: '平均数据',
  3185: '季前賽',
  3186: '常規賽',
  3187: '排名',
  3188: '東部',
  3189: '西部',
  3190: '新秀對抗賽',
  3191: '全明星賽',
  3192: '季後賽',
  3193: '第一圈',
  3194: '東部',
  3195: '西部',
  3196: '第二圈',
  3197: '東部',
  3198: '西部',
  3199: '分岸決賽',
  3200: '東部',
  3201: '西部',
  3202: '總決賽',
  3896: '季前賽',
  3897: '常規賽',
  3898: '星銳挑戰賽',
  3899: '全明星賽',
  3900: '半准決賽',
  3901: '准決賽',
  3902: '總決賽',
  3982: '季前賽',
  3983: '常規賽',
  3984: '排名',
  3985: '全明星賽',
  3986: '季後賽',
  3987: '第一圈',
  3988: '東部',
  3989: '西部',
  3990: '分岸決賽',
  3991: '東部',
  3992: '西部',
  3993: '總決賽',
  4004: '東部',
  4005: '西部',
  4293: '季前賽',
  4294: '常規賽',
  4295: '排名',
  4296: '東部',
  4297: '西部',
  4298: '新秀對抗賽',
  4299: '全明星賽',
  4300: '季後賽',
  4301: '第一圈',
  4302: '東部',
  4303: '西部',
  4304: '第二圈',
  4305: '東部',
  4306: '西部',
  4307: '分岸決賽',
  4308: '東部',
  4309: '西部',
  4310: '總決賽',
  4771: '季前賽',
  4772: '常規賽',
  4773: '星銳挑戰賽',
  4774: '全明星賽',
  4775: '半准決賽',
  4776: '准決賽',
  4777: '總決賽',
  4916: '季前賽',
  4917: '常規賽',
  4918: '排名',
  4919: '東部',
  4920: '西部',
  4921: '全明星賽',
  4922: '季後賽',
  4923: '第一圈',
  4924: '東部',
  4925: '西部',
  4926: '分岸決賽',
  4927: '東部',
  4928: '西部',
  4929: '總決賽',
  5143: '季前賽',
  5144: '常規賽',
  5145: '排名',
  5146: '東部',
  5147: '西部',
  5148: '新秀對抗賽',
  5149: '全明星賽',
  5150: '季後賽',
  5151: '第一圈',
  5152: '東部',
  5153: '西部',
  5154: '第二圈',
  5155: '東部',
  5156: '西部',
  5157: '分岸決賽',
  5158: '東部',
  5159: '西部',
  5160: '總決賽',
  5962: '季前賽',
  5963: '常規賽',
  5964: '星銳挑戰賽',
  5965: '全明星賽',
  5966: '半准決賽',
  5967: '准決賽',
  5968: '總決賽',
  6076: '季前賽',
  6077: '常規賽',
  6078: '排名',
  6079: '東部',
  6080: '西部',
  6081: '全明星賽',
  6082: '季後賽',
  6083: '第一圈',
  6084: '東部',
  6085: '西部',
  6086: '分岸決賽',
  6087: '東部',
  6088: '西部',
  6089: '總決賽',
  65667: '季前賽',
  65668: '常規賽',
  65669: '排名',
  65670: '東部',
  65671: '西部',
  65672: '新秀對抗賽',
  65673: '全明星賽',
  65674: '季後賽',
  65675: '第一圈',
  65676: '東部',
  65677: '西部',
  65678: '第二圈',
  65679: '東部',
  65680: '西部',
  65681: '分岸決賽',
  65682: '東部',
  65683: '西部',
  65684: '總決賽',
  65955: '季前賽',
  65956: '常規賽',
  65957: '星銳挑戰賽',
  65958: '全明星賽',
  65959: '半准決賽',
  65960: '准決賽',
  65961: '總決賽',
  66200: '季前賽',
  66201: '常規賽',
  66202: '排名',
  66203: '東部',
  66204: '西部',
  66205: '全明星賽',
  66206: '季後賽',
  66207: '第一圈',
  66208: '東部',
  66209: '西部',
  66210: '分岸決賽',
  66211: '東部',
  66212: '西部',
  66213: '總決賽',
  112691: '季前賽',
  112692: '常規賽',
  112693: '排名',
  112694: '東部',
  112695: '西部',
  112696: '新秀對抗賽',
  112697: '全明星賽',
  112698: '季後賽',
  112699: '第一圈',
  112700: '東部',
  112701: '西部',
  112702: '第二圈',
  112703: '東部',
  112704: '西部',
  112705: '分岸決賽',
  112706: '東部',
  112707: '西部',
  112708: '總決賽',
  113174: '常規賽',
  113175: '星銳挑戰賽',
  113176: '全明星賽',
  113177: '半准決賽',
  113178: '准決賽',
  113179: '總決賽',
  113275: '排名',
  113402: '季前賽',
  113403: '常規賽',
  113404: '排名',
  113405: '東部',
  113406: '西部',
  113407: '全明星賽',
  113408: '季後賽',
  113409: '第一圈',
  113410: '東部',
  113411: '西部',
  113412: '第二圈',
  113413: '東部',
  113414: '西部',
  113415: '准決賽',
  114158: '決賽',
  120700: '-',
  120703: '-',
  120706: '-'
}

export const playerLineup = {
  0: '其它',
  1: '前锋',
  2: '大前锋',
  3: '小前锋',
  4: '小前锋, 后卫',
  5: '大前锋, 中锋',
  6: '中锋',
  7: '中锋, 前锋',
  8: '后卫',
  9: '得分后卫',
  10: '前锋, 后卫',
  11: '控球后卫',
  12: '控球后卫, 前锋',
  13: '得分后卫, 前锋',
  14: '得分后卫, 控球后卫',
  15: '大前锋, 小前锋',
  16: '控球后卫, 大前锋',
  17: '控球后卫, 小前锋',
  18: '得分后卫, 大前锋',
  19: '得分后卫, 小前锋',
  20: '主教练'
}

export const common = {
  close: '关闭',
  cancel: '取消',
  notFoundText: '抱歉，您找的页面不存在'
}

export const noticeView = {
  loading: '加载中...',
  netError: '网络错误',
  noData: '没有数据',
  refreshBtnTitle: '点击刷新'
}

export const playerIndex = {
  height: '身高',
  bodyWeight: '体重',
  playerInfo: '球员信息',
  playerSeasonStats: '赛季数据',
  playerGameLogs: '比赛记录',
  playerCareerStats: '生涯数据',
  playerPosition: '位置',
  jerseyNumber: '俱乐部球衣号'
}

export const playerInfo = {
  playingTeam: '效力球队',
  playerHonor: '球员荣誉',
  playerProfile: '球员简介',
  currentTeam: '现属球队',
  joinTime: '加盟时间',
  salary: '薪金',
  formerTeam: '前效力球队',
  previousTeam: '曾效力球队'
}

export const playerSeasonStats = {
  avgStats: '赛季平均数据',
  recentMatch: '最近5场比赛',
  team: '球队',
  gamePlayed: '上场',
  minutes: '时间',
  rebounds: '篮板',
  assists: '助攻',
  steals: '抢断',
  blockShots: '盖帽',
  points: '得分',
  game: '比赛',
  title0: '常规赛',
  title1: '季后赛'
}

export const playerCareerStats = {
  regularSeasonData: '职业生涯常规赛数据',
  regularAvgSeasonData: '职业生涯常规赛平均数据',
  playoffStatistics: '职业生涯季后赛数据',
  playoffAvgStatistics: '职业生涯季后赛平均数据',
  career: '生涯',
  years: '年份'
}

export const teamIndex = {
  founded: '成立',
  officialWebsite: '官网',
  fixture: '赛程',
  trackRecord: '往绩',
  coach: '教练',
  playerList: '球员',
  info: '资料'
}

export const teamTrackRecord = {
  confrontationRecordTitle: '近20场交锋',
  win: '胜',
  win2: '赢',
  lose: '负',
  lose2: '输',
  over: '大',
  under: '小',
  winRatio: '胜率',
  payoutWinRatio: '赢率',
  overRatio: '大分率',
  singleDigitRatio: '单率',
  sectionTitle: '近20场',
  home: '主',
  away: '客',
  neutralCourt: '中',
  game: '场',
  result: '胜负',
  pointsSpread: '让分',
  payout: '盘路',
  totalScore: '总分',
  totalScorePayout: '总分盘',
  overTime: '加时'
}

export const teamCoach = {
  birthday: '生日',
  country: '国籍',
  formerTeam: '前度球队',
  previousTeam: '曾效力球会',
  honor: '个人荣誉',
  profile: '简介'
}

export const teamPlayerList = {
  number: '号'
}

export const teamInfo = {
  championshipRecord: '冠军记录',
  retiredJersey: '退役球衣',
  courseIntroduction: '球场介绍',
  homeCourt: '主场',
  capacity: '容纳人数',
  openYear: '开始使用年份',
  address: '地址'
}

export const leagueIndex = {
  schedule: '赛程',
  rank: '排名',
  competitionRules: '赛制'
}

export const leagueRank = {
  teamRank: '球队排名',
  east: '东部',
  west: '西部'
}

export const leagueCompetitionRules = {
  title: '赛制说明'
}

export const weekDay = {
  0: '星期日',
  1: '星期一',
  2: '星期二',
  3: '星期三',
  4: '星期四',
  5: '星期五',
  6: '星期六'
}
